import classNames from 'classnames';
import styles from './styles.module.scss';

export const IconWInfo = (
  {
    className, top, bottom, text, Icon, title,
  }:{
    className?: string,
    top?: string,
    text: string,
    Icon: React.FC<{ className?: string }>,
    bottom?: string,
    title?: string,
  },
) => (
  <figure className={classNames(styles.box, className)}>
    <div title={title}>
      <Icon className={styles.icon} />
      {top && <div className={styles.textUnderIcon}>{top}</div>}
    </div>
    <div>
      <figcaption className={styles.value}>{text}</figcaption>
      {bottom && <div className={styles.secondary}>{bottom}</div>}
    </div>
  </figure>
);
